import { imageUrl } from '@helpers/image';
import * as React from 'react';
import S from './ArticleSummary.styles';
const ArticleSummary = ({ headingLevel, image, tabIndex, tag, title, url, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Link, { href: url, tabIndex: tabIndex },
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: "", loading: "lazy", role: "presentation", src: imageUrl(image, { width: 185, height: 134 }) })),
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Tag, null, tag),
                React.createElement(S.Title, { as: headingLevel }, title)))));
};
export default ArticleSummary;
